<template>
    <div class="content-dashboard">
        <div class="title">라이센스 현황</div>
        <div class="chart-select-common">
            <el-date-picker
              v-model="dateData"
              type="date"
              @change="getList"
            />
        </div>
        <div class="chart-donut" id="LicenceDonut"></div>
        <div
            class="box-statistics-common"
            v-for="(item, index) in chartData"
            :key="`chartItem${index}`"
        >
            <div class="statistics-circle-common" :style="`background: ${item.itemStyle.color}`"></div>
            <div class="statistics-title-common">{{ item.name }}</div>
            <div class="statistics-text-common">{{ returnCommas(item.value) }}개({{ (item.value / totalCount * 100).toFixed(2) }}%)</div>
        </div>
    </div>
</template>


<script>
import util from "@/mixins/util";
import * as echarts from "echarts";
import dateMixins from "@/mixins/dateMixins";
// import NumberMixins from "@/mixins/NumberMixins"
export default {
    name: "DashboardLicenceLayout",
    mixins: [
        // NumberMixins
        dateMixins
    ],
    components: {},
    props: {},
    data() {
        return {
            totalCount: 0,
            chartData: [],
            dateData : new Date(),
            dashData : [],
            colorData : ['#96EFFF','#C5FFF8','#FFC5C5','#FF90BC','#8DDFCB','#82A0D8','#79AC78','#D0BFFF','#F2BED1','#D2E9E9','#FFB4B4','#B9F3E4','#FFB9B9','#FF8787','#9CB4CC','#9ADCFF','#FFF89A','#D7E9F7','#F38BA0','#C490E4'],
            donutChart: null,
        
        };
    },
    beforeRouterEnter() {},
    created() {
        this.getList();
    },
    mounted() {
    },
    beforeUnmount() {},
    unmounted() {},
    computed: {},
    methods: {
        returnCommas(price) {
            if (!util.isEmpty(price)) {
                return util.Number.numFormat(price);
            } else {
                return 0;
            }
        },
        getList() {
            let params ={};
            params.day = this.returnDateFormat(this.dateData,"YYYY-MM-DD");
            this.$api.$dash.getLicenseList(params).then(data => data.Data.result).then(res => {
                if (res.Info.status) {
                    this.dashData = res.List;
                } else {
                    this.dashData = [];
                }
                this.setData();
            })
        },

        setData() {
            this.chartData = [];
            this.totalCount =0;
            for (let i = 0; i < this.dashData.length; i++) {
                let data = this.dashData[i];
                this.totalCount += data.cnt;
                let object = {
                    value: data.cnt,
                    name: data.pl_title,
                    itemStyle: {
                        color: this.colorData[i % 20],
                        decal: {
                            symbol: "none",
                        },
                    },
                }
                this.chartData.push(object);
            }
            this.setDonut();
        },

        setDonut() {
            let chartDom = document.getElementById("LicenceDonut");
            this.donutChart = echarts.init(chartDom, null, {});
            let option = {
                tooltip: {
                    trigger: "item",
                },
                series: [
                    {
                        name: "",
                        type: "pie",
                        radius: ["40%", "70%"],
                        avoidLabelOverlap: false,
                        label: {
                            show: false,
                            position: "center",
                        },
                        labelLine: {
                            show: false,
                        },
                        data: this.chartData,
                    },
                ],
            };
            this.donutChart.clear();
            this.donutChart.setOption(option);
        },
    },
    watch: {},
};
</script>
